import { useCallback } from "react";
import { useExportBatchTransactions } from "../../../../hooks/queries/useBulkUploadsQueries";
import { toastService } from "../../../../providers";

export const useBatchTransactionsExport = (batchId, apiFilters = {}) => {
  const { mutate: exportBatchTransactions, isPending } =
    useExportBatchTransactions(batchId, apiFilters);

  const handleExport = useCallback(() => {
    toastService.info("Exporting. Your download will begin shortly...");

    exportBatchTransactions(undefined, {
      onSuccess: (response) => {
        const blob = response.data;
        const url = globalThis.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `batch_transactions_${batchId}_${new Date().toISOString().slice(0, 10)}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(url);
        toastService.success("Export complete! Download started.");
      },
      onError: () => {
        toastService.error("Failed to export. Please try again.");
      },
    });
  }, [exportBatchTransactions, batchId]);

  return {
    handleExport,
    isExporting: isPending,
  };
};

export default useBatchTransactionsExport;
